/* ------- Motion primitives ------- */
const prefersReduced = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || false;
const calmMotion = true;

/* ------- Intro loader dismiss — MUST run first, before anything that could crash.
   Belt-and-suspenders on top of the CSS failsafe animation. ------- */
(function(){
  try {
    const l = document.getElementById('loader');
    if (!l) return;
    const dismiss = () => {
      if (l.classList.contains('gone')) return;
      l.classList.add('gone');
      setTimeout(() => { try { l.remove(); } catch(_) {} }, 350);
    };
    const dwell = prefersReduced ? 60 : 150;
    // Three triggers: on window load, after dwell timer, and a hard safety net
    window.addEventListener('load', () => setTimeout(dismiss, dwell));
    setTimeout(dismiss, dwell + 400);
    setTimeout(dismiss, 1200); // hard ceiling regardless of anything else
  } catch(_) { /* loader removal failed, CSS failsafe takes over at 3s */ }
})();

/* Six Acts — scroll-driven day controller for #framer-demo */
function initSixActs(){
  const root = document.querySelector('.six-acts');
  if(!root) return;
  if(root.dataset.saReady === 'true') return;
  root.dataset.saReady = 'true';

  const acts = [
    { h:'Before you go.',
      p:"The wall surfaces what's about to be missed — not what's already on the calendar. Emma's permission slip needs a signature before 8.",
      meta:['Smart card','Calendar-aware','One decision, surfaced'],
      bg:'linear-gradient(180deg,#F8E5C5 0%, #EFD2B0 100%)',
      sun:{x:-30,y:6,o:.95} },
    { h:'The morning move.',
      p:"Three people in motion, one wall. Mantle pulls live status from your household — not raw GPS. Kids share status, not coordinates.",
      meta:['Map view','Status, not surveillance','Live transit'],
      bg:'linear-gradient(180deg,#FBEAD0 0%, #F5E2C7 100%)',
      sun:{x:-15,y:0,o:1} },
    { h:'The 4:30 scramble.',
      p:"Soccer at 4:30. Rain at 5:30. The wall sees the conflict before the group text starts and gives the operator one move.",
      meta:['Leave-by card','Conflict-aware','Quiet preview'],
      bg:'linear-gradient(180deg,#F5E2C7 0%, #EFD2B0 100%)',
      sun:{x:25,y:14,o:.85} },
    { h:'Pickup, assigned.',
      p:"Mantle turns location into a household decision, not a surveillance ping. The closest parent gets the ask. One tap to confirm.",
      meta:['Pickup alert','Closest-first','One tap to confirm'],
      bg:'linear-gradient(180deg,#F2DBB7 0%, #E7CCA0 100%)',
      sun:{x:40,y:32,o:.7} },
    { h:'Dinner check.',
      p:"All home by 7:15. Tags say keys, backpack, and water bottle made it home too. The line between 'a list' and 'a system' is the wall that updates itself.",
      meta:['Dinner card','Tags accounted','Self-updating'],
      bg:'linear-gradient(180deg,#E8C99B 0%, #D5A86C 100%)',
      sun:{x:55,y:60,o:.5} },
    { h:'Lights out.',
      p:"The room dims. The wall does too. A quiet preview of tomorrow — early pickup, rain — for the operator who's still up. Then it sleeps.",
      meta:['Tomorrow card','Auto-dim','One last look'],
      bg:'linear-gradient(180deg,#2A3756 0%, #141B2E 100%)',
      sun:{x:70,y:120,o:0} }
  ];

  const layers = root.querySelectorAll('.sa-layer');
  const items = root.querySelectorAll('.sa-act-item');
  const spacers = root.querySelectorAll('.sa-act-spacer');
  const stageBg = root.querySelector('[data-sa-bg]');
  const sun = root.querySelector('[data-sa-sun]');
  const capH = root.querySelector('[data-sa-caption-h]');
  const capP = root.querySelector('[data-sa-caption-p]');
  const capMeta = root.querySelector('[data-sa-caption-meta]');

  let currentAct = -1;

  function setAct(i){
    if(i === currentAct) return;
    if(i < 0 || i >= acts.length) return;
    currentAct = i;
    const a = acts[i];
    layers.forEach(l => l.classList.toggle('is-active', +l.dataset.act === i));
    items.forEach(it => it.classList.toggle('is-active', +it.dataset.jump === i));
    if(capH) capH.textContent = a.h;
    if(capP) capP.textContent = a.p;
    if(capMeta) capMeta.innerHTML = a.meta.map(m => '<span>' + m + '</span>').join('');
    if(stageBg) stageBg.style.background = a.bg;
    if(sun){
      sun.style.transform = 'translateX(calc(-50% + ' + a.sun.x + 'vw)) translateY(' + a.sun.y + 'vh)';
      sun.style.opacity = a.sun.o;
    }
  }

  // Pick the spacer whose center is closest to viewport center.
  function pickActFromScroll(){
    const center = window.innerHeight / 2;
    let best = null;
    spacers.forEach(s => {
      const r = s.getBoundingClientRect();
      const sCenter = r.top + r.height / 2;
      const d = Math.abs(sCenter - center);
      if(best === null || d < best.d) best = { el:s, d };
    });
    if(best && best.d < window.innerHeight) setAct(+best.el.dataset.act);
  }

  if(spacers.length){
    const io = new IntersectionObserver(pickActFromScroll, {
      threshold:[0,.25,.5,.75,1],
      rootMargin:'-30% 0px -30% 0px'
    });
    spacers.forEach(s => io.observe(s));

    let raf = 0;
    window.addEventListener('scroll', () => {
      if(raf) return;
      raf = requestAnimationFrame(() => { raf = 0; pickActFromScroll(); });
    }, { passive:true });

    // Initial paint
    pickActFromScroll();
  } else {
    setAct(0);
  }

  // Left-rail click → scroll the matching spacer to viewport center.
  items.forEach(it => {
    it.addEventListener('click', () => {
      const target = spacers[+it.dataset.jump];
      if(target) target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block:'center' });
    });
  });
}

function safelyInitSixActs(){
  try { initSixActs(); }
  catch (err) { console.warn('[six-acts] Failed to initialize:', err); }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', safelyInitSixActs, { once: true });
} else {
  safelyInitSixActs();
}

/* ------- Global error net — any uncaught error shouldn't prevent later code from running.
   This doesn't mask bugs (console still logs them), it just prevents cascade failures. ------- */
window.addEventListener('error', (e) => {
  console.warn('[mantle.js] Caught error, continuing:', e.message, 'at', e.filename + ':' + e.lineno);
});

/* ------- Attribution capture for server-side conversion mirroring ------- */
(function initAttributionContext() {
  const CLICK_ID_KEYS = ['gclid', 'gbraid', 'wbraid', 'msclkid', 'fbclid', 'ttclid', 'twclid', 'rdt_cid', 'li_fat_id', 'epik'];
  const COOKIE_KEYS = ['_fbp', '_fbc', '_ga', '_ttp', 'ttp', '_uetvid', '_uetsid', '_rdt_uuid', '_pin_unauth'];
  const REFERRAL_PARAM_KEYS = ['ref', 'referral', 'referral_code', 'vl_referrer', 'vl_referral', 'viral_loops'];
  const CLICK_STORAGE_KEY = 'mantle_click_ids';
  const REFERRAL_STORAGE_KEY = 'mantle_referral_context';
  const LANDING_STORAGE_KEY = 'mantle_landing_context';
  const CLICK_TTL_MS = 90 * 24 * 60 * 60 * 1000;

  function safeJsonParse(raw, fallback) {
    try { return raw ? JSON.parse(raw) : fallback; }
    catch (_) { return fallback; }
  }

  function readLocal(key, fallback) {
    try { return safeJsonParse(window.localStorage.getItem(key), fallback); }
    catch (_) { return fallback; }
  }

  function writeLocal(key, value) {
    try { window.localStorage.setItem(key, JSON.stringify(value)); }
    catch (_) {}
  }

  function readSession(key, fallback) {
    try { return safeJsonParse(window.sessionStorage.getItem(key), fallback); }
    catch (_) { return fallback; }
  }

  function writeSession(key, value) {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); }
    catch (_) {}
  }

  function getSearchParams() {
    try { return new URLSearchParams(window.location.search); }
    catch (_) { return new URLSearchParams(); }
  }

  function pruneClickIds(stored, now) {
    const next = {};
    Object.keys(stored || {}).forEach((key) => {
      const item = stored[key];
      if (!item || !item.value || !item.expiresAt || item.expiresAt <= now) return;
      next[key] = item;
    });
    return next;
  }

  function persistClickIds() {
    const params = getSearchParams();
    const now = Date.now();
    const stored = pruneClickIds(readLocal(CLICK_STORAGE_KEY, {}), now);
    let changed = false;

    CLICK_ID_KEYS.forEach((key) => {
      const value = (params.get(key) || '').trim();
      if (!value) return;
      stored[key] = {
        value,
        capturedAt: new Date(now).toISOString(),
        expiresAt: now + CLICK_TTL_MS
      };
      changed = true;
    });

    if (changed) writeLocal(CLICK_STORAGE_KEY, stored);
  }

  function persistReferralContext() {
    const params = getSearchParams();
    const now = Date.now();
    let matchedKey = null;
    let matchedValue = null;

    REFERRAL_PARAM_KEYS.some((key) => {
      const value = (params.get(key) || '').trim();
      if (!value) return false;
      matchedKey = key;
      matchedValue = value;
      return true;
    });

    if (!matchedValue) return;

    writeLocal(REFERRAL_STORAGE_KEY, {
      code: matchedValue,
      param: matchedKey,
      landing_page: window.location.href,
      capturedAt: new Date(now).toISOString(),
      expiresAt: now + CLICK_TTL_MS
    });
  }

  function getStoredClickIds() {
    const stored = pruneClickIds(readLocal(CLICK_STORAGE_KEY, {}), Date.now());
    const clickIds = {};
    Object.keys(stored).forEach((key) => {
      clickIds[key] = stored[key].value;
    });
    return clickIds;
  }

  function getStoredReferralContext() {
    const stored = readLocal(REFERRAL_STORAGE_KEY, null);
    if (!stored || !stored.code || !stored.expiresAt || stored.expiresAt <= Date.now()) return null;
    return {
      code: stored.code,
      param: stored.param,
      landing_page: stored.landing_page,
      capturedAt: stored.capturedAt
    };
  }

  function readCookie(name) {
    try {
      const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    } catch (_) {
      return null;
    }
  }

  function compact(obj) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === null || obj[key] === undefined || obj[key] === '') delete obj[key];
    });
    return obj;
  }

  function getCookieContext() {
    const cookies = {};
    COOKIE_KEYS.forEach((key) => {
      cookies[key] = readCookie(key);
    });
    return compact(cookies);
  }

  function captureLandingContext() {
    const existing = readSession(LANDING_STORAGE_KEY, null);
    if (existing && existing.landing_page) return;
    writeSession(LANDING_STORAGE_KEY, {
      landing_page: window.location.href,
      referrer: document.referrer || null,
      capturedAt: new Date().toISOString()
    });
  }

  window.getAttributionContext = function getAttributionContext() {
    const landing = readSession(LANDING_STORAGE_KEY, {}) || {};
    return {
      click_ids: getStoredClickIds(),
      cookies: getCookieContext(),
      referral: getStoredReferralContext(),
      landing_page: landing.landing_page || window.location.href,
      referrer: landing.referrer || document.referrer || null,
      user_agent: navigator.userAgent,
      page: window.location.href
    };
  };

  try {
    persistClickIds();
    persistReferralContext();
    captureLandingContext();
  } catch (err) {
    console.warn('[attribution] Failed to initialize attribution context:', err);
  }
})();

/* ------- Analytics fan-out: GA4, GTM/dataLayer, PostHog, Meta Pixel, ad pixels ------- */
const MANTLE_CONVERSION_EVENTS = new Set(['invite_application_submit', 'preorder_complete']);

function createMantleEventId() {
  try {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
  } catch (_) {}
  return 'mantle-' + Date.now() + '-' + Math.random().toString(36).slice(2, 12);
}

function mantleTrack(eventName, props = {}) {
  const settings = window.MANTLE_SETTINGS || {};
  const payload = {
    ...props,
    path: window.location.pathname,
    compare_variant: document.documentElement.getAttribute('data-compare-variant') || 'unassigned',
    overture_variant: document.documentElement.classList.contains('skip-overture')
      ? 'skipped'
      : (document.documentElement.getAttribute('data-overture-variant') || 'unassigned')
  };

  if (typeof gtag === 'function' && settings.ga4_id) {
    gtag('event', eventName, { ...payload, send_to: settings.ga4_id });
  }
  if (window.dataLayer) {
    window.dataLayer.push({ event: eventName, ...payload });
  }
  if (window.posthog && typeof window.posthog.capture === 'function') {
    window.posthog.capture(eventName, payload);
  }
  if (typeof fbq === 'function') {
    const metaEvent = eventName === 'preorder_complete' ? 'Purchase' : (eventName === 'invite_application_submit' ? 'Lead' : null);
    const metaPayload = { event_name: eventName, ...payload };
    if (metaEvent) {
      const options = payload.event_id ? { eventID: payload.event_id } : null;
      if (options) fbq('track', metaEvent, metaPayload, options);
      else fbq('track', metaEvent, metaPayload);
    } else {
      fbq('trackCustom', 'CustomEvent', metaPayload);
    }
  }

  if (MANTLE_CONVERSION_EVENTS.has(eventName)) {
    const label = payload.event_label || payload.label || eventName;
    const isInviteConversion = eventName === 'invite_application_submit';

    if (window.uetq && typeof window.uetq.push === 'function') {
      window.uetq.push('event', eventName, {
        event_category: 'conversion',
        event_label: label,
        event_value: payload.value,
        event_id: payload.event_id
      });
    }
    if (isInviteConversion && typeof window.lintrk === 'function' && settings.linkedin_invite_conversion_id) {
      window.lintrk('track', { conversion_id: settings.linkedin_invite_conversion_id });
    }
    if (window.ttq && typeof window.ttq.track === 'function') {
      const tiktokEvent = eventName === 'preorder_complete' ? 'Purchase' : 'Lead';
      window.ttq.track(tiktokEvent, {
        event_id: payload.event_id,
        value: payload.value,
        currency: payload.currency || 'USD'
      });
    }
    if (typeof window.rdt === 'function') {
      const redditEvent = eventName === 'preorder_complete' ? 'Purchase' : 'Lead';
      window.rdt('track', redditEvent, {
        transactionId: payload.event_id,
        value: payload.value,
        currency: payload.currency || 'USD'
      });
    }
    if (typeof window.pintrk === 'function') {
      const pinterestEvent = eventName === 'preorder_complete' ? 'checkout' : 'lead';
      const pinterestPayload = {
        event_id: payload.event_id,
        value: payload.value,
        currency: payload.currency || 'USD'
      };
      if (isInviteConversion) pinterestPayload.lead_type = 'invite_application';
      window.pintrk('track', pinterestEvent, pinterestPayload);
    }
    if (isInviteConversion && typeof window.twq === 'function' && settings.twitter_invite_event_id) {
      window.twq('event', settings.twitter_invite_event_id, {
        conversion_id: payload.event_id,
        value: payload.value,
        currency: payload.currency || 'USD'
      });
    }
    if (isInviteConversion && typeof gtag === 'function' && settings.google_ads_invite_label) {
      gtag('event', 'conversion', {
        send_to: settings.google_ads_invite_label,
        value: payload.value,
        currency: payload.currency || 'USD',
        transaction_id: payload.event_id
      });
    }
  }
}
window.mantleTrack = mantleTrack;

function initAnalyticsClickTracking() {
  document.querySelectorAll('[data-analytics-event]').forEach((el) => {
    if (el.dataset.analyticsReady === 'true') return;
    el.dataset.analyticsReady = 'true';
    el.addEventListener('click', () => {
      mantleTrack(el.dataset.analyticsEvent, {
        label: el.dataset.analyticsLabel || el.textContent.trim(),
        href: el.getAttribute('href') || null
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAnalyticsClickTracking, { once: true });
} else {
  initAnalyticsClickTracking();
}

/* Overture routing lives inline in layout/mantle.liquid <head> so the
   html.skip-overture class is set before first paint (required by the
   variant-aware .hero-core CSS toggle — v3.2). */

/* ------- Nav scroll + scroll progress ------- */
const nav = document.getElementById('nav');
const progress = document.getElementById('scrollProgress');
function onScroll(){
  const y = window.scrollY;
  nav.classList.toggle('scrolled', y > 8);
  if(progress){
    const h = document.documentElement.scrollHeight - window.innerHeight;
    const pct = h > 0 ? Math.min(1, y / h) : 0;
    progress.style.transform = `scaleX(${pct})`;
  }
  /* Hero: fade the whole stage as you scroll past it (skip at top so entrance animation plays) */
  if(!prefersReduced){
    const stage = document.querySelector('.hero-stage');
    if(stage){
      if(y < 40){ stage.style.opacity = ''; }
      else{
        const max = 520;
        const t = Math.max(0, Math.min(1, y / max));
        stage.style.opacity = (1 - t*0.35).toFixed(3);
      }
    }
  }
}
window.addEventListener('scroll', onScroll, {passive:true});
onScroll();

/* ------- IntersectionObserver: reveal-on-scroll (toggles, so animations replay on scroll-up) ------- */
const io = new IntersectionObserver((entries)=>{
  entries.forEach(e=>{
    // Toggle .in-view based on intersection — replays animation when re-entering viewport
    e.target.classList.toggle('in-view', e.isIntersecting);
  });
}, {threshold:0.12, rootMargin:'0px 0px -60px 0px'});

/* Auto-tag elements so the markup stays clean */
const REVEAL_SELECTORS = [
  'section > .wrap > *',
  'section > .wrap-narrow > *',
  '.chapter-inner > *',
  '.conversion-strip',
  '.conversion-step',
  '.fb-meter',
  '.nf-card',
  '.vl-cards > *',
  '.problem-grid > *',
  '.phone-card .phone-row',
  '.phone-card .chat-bubble',
  '.how-grid > *',
  '.view-block > *',
  '.cards-scroll > *',
  '.privacy-grid > *',
  '.privacy-edge',
  '.privacy-bullets > *',
  '.tablet-grid > *',
  '.compare-grid > *',
  '.compare-wellness .compare-beat > *',
  '.compare-summary > *',
  '.price-device',
  '.price-device-v2 .pd-features > *',
  '.price-plans > *',
  '.invite-form',
  '.invite-form > *',
  '.founding',
  '.tags-grid > *',
  '.tags-features > *',
  '.tags-wild > *',
  '.tags-split > *',
  '.tags-features-grid > *',
  '.tags-packs > *',
  '.price-guarantee',
  '.faq-grid > *',
  '.capture-inner > *',
  'footer .footer-col',
  '.tags-stage',
  '.mv-pin',
  /* Editorial layers ported from "A Day in Six Acts" (2026-04-28) */
  '.mte-chapter',
  '.mte-stat-band-inner > *',
  '.mte-stat-row > *',
  '.mte-scene-inner > *',
  '.mte-wall-inner > *',
  '.mte-box-inner > *',
  '.mte-box-list > *',
  '.mte-closing-inner > *'
];

REVEAL_SELECTORS.forEach(sel=>{
  document.querySelectorAll(sel).forEach((el, i)=>{
    if(el.closest('.reveal-skip')) return;
    el.classList.add('reveal');
    el.style.setProperty('--d', (Math.min(i,6) * 0.07) + 's');
    io.observe(el);

    // Immediate check: if already in viewport, mark .in-view right now.
    // Don't wait for the async IO callback — some environments (iframes,
    // private mode, strict CSPs) delay or drop it.
    try {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('in-view');
      }
    } catch(_) { el.classList.add('in-view'); }
  });
});

/* Failsafes for .reveal elements — if IntersectionObserver silently fails,
   progressively force elements visible. Three escalating tiers. */
(function(){
  // Tier 1: 800ms — anything within 1.5× viewport gets revealed
  setTimeout(() => {
    document.querySelectorAll('.reveal:not(.in-view)').forEach(el => {
      try {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.5) el.classList.add('in-view');
      } catch(_) {}
    });
  }, 800);

  // Tier 2: 2500ms — anything within 3× viewport
  setTimeout(() => {
    document.querySelectorAll('.reveal:not(.in-view)').forEach(el => {
      try {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 3) el.classList.add('in-view');
      } catch(_) {}
    });
  }, 2500);

  // Tier 3 (nuclear): 5000ms — force every .reveal element visible, no matter where
  setTimeout(() => {
    document.querySelectorAll('.reveal:not(.in-view)').forEach(el => el.classList.add('in-view'));
  }, 5000);
})();

/* Word-split for key headlines — karaoke-style reveal */
function splitWords(el){
  if(el.dataset.split) return;
  el.dataset.split = '1';
  const nodes = [...el.childNodes];
  el.innerHTML = '';
  nodes.forEach(node=>{
    if(node.nodeType === 3){
      const words = node.textContent.split(/(\s+)/);
      words.forEach((w, i)=>{
        if(/^\s+$/.test(w)){ el.appendChild(document.createTextNode(w)); return; }
        const s = document.createElement('span');
        s.className = 'word';
        s.textContent = w;
        el.appendChild(s);
      });
    } else {
      el.appendChild(node);
    }
  });
  const words = el.querySelectorAll('.word');
  words.forEach((w, i)=>{
    w.style.setProperty('--wd', (i * 0.05) + 's');
  });
  el.classList.add('split');
  io.observe(el);
}

document.querySelectorAll(
  '.hero h1, .chapter h2, .section-title, .problem h2, .capture h2, .tags-copy h2, .compare-lede h2, .privacy h2, .overture-h, .compare-wellness .comp-card .name'
).forEach(splitWords);

/* Counter animation — count numbers up on reveal */
function parseTarget(el){
  const t = el.getAttribute('data-to') || el.textContent.trim();
  const match = t.match(/(\$?)([\d,]+)(.*)?/);
  if(!match) return null;
  return {prefix: match[1]||'', value: parseInt(match[2].replace(/,/g,''),10), suffix: match[3]||''};
}
function animateCount(el){
  const t = parseTarget(el); if(!t) return;
  el.classList.add('counter-num');
  const dur = 900; const start = performance.now();
  function frame(now){
    const p = Math.min(1, (now - start)/dur);
    const eased = 1 - Math.pow(1-p, 3);
    const v = Math.round(t.value * eased);
    el.textContent = t.prefix + v.toLocaleString() + t.suffix;
    if(p < 1) requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
}
const countIo = new IntersectionObserver((entries)=>{
  entries.forEach(e=>{
    if(e.isIntersecting){ animateCount(e.target); countIo.unobserve(e.target); }
  });
},{threshold:.4});
document.querySelectorAll('.price-device .amt, .plan .amt-main, .pack .count')
  .forEach(el=>{ if(prefersReduced) return; countIo.observe(el); });

/* Smart-card scroll: show the "there's more" hint once when revealed */
const cardsScroll = document.getElementById('cardsScroll');
if(cardsScroll && !prefersReduced){
  const hintIo = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{ if(e.isIntersecting){ cardsScroll.classList.add('hint'); hintIo.unobserve(e.target); } });
  },{threshold:.35});
  hintIo.observe(cardsScroll);
}

/* Button ripple cursor position + magnetic pull on primary CTAs */
document.querySelectorAll('.btn').forEach(b=>{
  const magnetic = !calmMotion && (b.classList.contains('btn-primary') || b.classList.contains('btn-dark'));
  b.addEventListener('mousemove', (e)=>{
    const r = b.getBoundingClientRect();
    b.style.setProperty('--mx', (e.clientX - r.left)+'px');
    b.style.setProperty('--my', (e.clientY - r.top)+'px');
    if(magnetic && !prefersReduced){
      const mx = e.clientX - r.left - r.width/2;
      const my = e.clientY - r.top - r.height/2;
      b.style.transform = `translate(${mx*0.18}px, ${my*0.22}px)`;
    }
  });
  b.addEventListener('mouseleave', ()=>{ if(magnetic) b.style.transform=''; });
});

/* 3D tilt on smart-cards */
if(!calmMotion && !prefersReduced){
  document.querySelectorAll('.smart-card').forEach(card=>{
    card.addEventListener('mousemove', (e)=>{
      const r = card.getBoundingClientRect();
      const mx = (e.clientX - r.left)/r.width - .5;
      const my = (e.clientY - r.top )/r.height - .5;
      card.style.transform =
        `translateY(-4px) rotateY(${mx*7}deg) rotateX(${-my*6}deg)`;
    });
    card.addEventListener('mouseleave', ()=>{ card.style.transform=''; });
  });
}

/* Scroll-parallax on chapter & tag stages */
const parallaxEls = document.querySelectorAll(
  '.ch-stage-wall, .ch-stage-object, .ch-stage-little, .tags-stage'
);
function updateParallax(){
  if(calmMotion || prefersReduced) return;
  const vh = window.innerHeight;
  parallaxEls.forEach(el=>{
    const r = el.getBoundingClientRect();
    const center = r.top + r.height/2;
    const t = Math.max(-1, Math.min(1, (center - vh/2) / vh));
    el.style.transform = `translateY(${t * -22}px)`;
  });
}
window.addEventListener('scroll', updateParallax, {passive:true});
updateParallax();

/* Sticky floating CTA show/hide -- hide when any prominent in-page CTA section is in view */
const stickyCTA = document.getElementById('stickyCTA');
const ctaSectionIds = ['invite-application', 'founder', 'invite-loop', 'pricing'];
const ctaSections = ctaSectionIds.map(id => document.getElementById(id)).filter(Boolean);
function updateStickyCTA(){
  if(!stickyCTA) return;
  const y = window.scrollY;
  const docH = document.documentElement.scrollHeight;
  let near = y > 640 && y < (docH - window.innerHeight - 520);
  if (near) {
    for (const el of ctaSections) {
      const r = el.getBoundingClientRect();
      const inSection = r.top < window.innerHeight * 0.88 && r.bottom > window.innerHeight * 0.12;
      if (inSection) { near = false; break; }
    }
  }
  stickyCTA.classList.toggle('show', near);
}
window.addEventListener('scroll', updateStickyCTA, {passive:true});
updateStickyCTA();

/* Cycling hero eyebrow — single text-node swap, no pile-up possible */
const eyebrowCycle = document.getElementById('eyebrowCycle');
if(eyebrowCycle && !prefersReduced && !eyebrowCycle.dataset.cycleInit){
  eyebrowCycle.dataset.cycleInit = '1'; // guard against double-init (hot reload etc.)
  const phrases = [
    'One wall. One plan. For the one running the house.',
    'Invite-gated · 200 numbered Founding Families',
    'Ships Fall 2026 · aiming before Christmas',
    'No camera. No microphone. No app to open.'
  ];
  let idx = 0;
  // Clear anything the server rendered, set inline styles so this works even if CSS is late
  eyebrowCycle.innerHTML = '';
  eyebrowCycle.style.display = 'inline-block';
  eyebrowCycle.style.transition = 'opacity .25s ease';
  eyebrowCycle.style.opacity = '1';
  eyebrowCycle.textContent = phrases[0];
  setInterval(()=>{
    idx = (idx + 1) % phrases.length;
    eyebrowCycle.style.opacity = '0';
    setTimeout(()=>{
      eyebrowCycle.textContent = phrases[idx];
      eyebrowCycle.style.opacity = '1';
    }, 260);
  }, 3600);
}

/* Parallax: schedule-view inside hero subtly drifts on mouse */
const wall = document.querySelector('.wall');
const device = document.querySelector('.hero-stage .device');
if(wall && device && !calmMotion && !prefersReduced){
  wall.addEventListener('mousemove', (e)=>{
    const r = wall.getBoundingClientRect();
    const mx = ((e.clientX - r.left)/r.width - .5);
    const my = ((e.clientY - r.top )/r.height - .5);
    device.style.transform = `translate(calc(-50% + ${mx*8}px), calc(-58% + ${my*6}px)) rotateY(${mx*2}deg) rotateX(${-my*2}deg)`;
  });
  wall.addEventListener('mouseleave', ()=>{
    device.style.transform = '';
  });
}

/* ============================================================
   Pass 3 — intro loader, custom cursor, grain, live clock,
   chapter numbers, particle field, page color morph
   ============================================================ */

/* Intro loader dismiss is now at the top of this file (line 4) — runs before any code that could crash. */

/* Custom cursor */
(function(){
  if(calmMotion || !window.matchMedia('(pointer:fine)').matches || prefersReduced) return;
  const dot = document.createElement('div');
  const ring = document.createElement('div');
  dot.className = 'cursor-dot';
  ring.className = 'cursor-ring';
  document.body.append(dot, ring);
  let mx = window.innerWidth/2, my = window.innerHeight/2;
  let rx = mx, ry = my;
  document.addEventListener('mousemove', (e)=>{
    mx = e.clientX; my = e.clientY;
    dot.style.transform = `translate3d(${mx}px, ${my}px, 0) translate(-50%,-50%)`;
    document.body.classList.add('cursor-ready');
  });
  document.addEventListener('mouseleave', ()=> document.body.classList.remove('cursor-ready'));
  document.addEventListener('mouseenter', ()=> document.body.classList.add('cursor-ready'));
  document.addEventListener('mousedown', ()=> document.body.classList.add('cursor-down'));
  document.addEventListener('mouseup',   ()=> document.body.classList.remove('cursor-down'));
  (function tick(){
    rx += (mx - rx) * 0.18;
    ry += (my - ry) * 0.18;
    ring.style.transform = `translate3d(${rx}px, ${ry}px, 0) translate(-50%,-50%)`;
    requestAnimationFrame(tick);
  })();
  const hoverSel = 'a, button, .btn, .faq-item, .smart-card, .tag, .phone-card, .pack, .plan, .comp-card, .view-frame, input, .marquee-item, .sticky-cta';
  document.addEventListener('mouseover', (e)=>{
    if(e.target.closest && e.target.closest(hoverSel)) document.body.classList.add('cursor-hover');
  });
  document.addEventListener('mouseout', (e)=>{
    if(e.target.closest && e.target.closest(hoverSel)) document.body.classList.remove('cursor-hover');
  });
})();

/* Live clock + date in hero UI screens */
function updateClock(){
  const now = new Date();
  const h24 = now.getHours();
  const h12 = ((h24 + 11) % 12) + 1;
  const m = String(now.getMinutes()).padStart(2,'0');
  const days = ['SUN','MON','TUE','WED','THU','FRI','SAT'];
  const months = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  const dateStr = `${days[now.getDay()]} · ${months[now.getMonth()]} ${now.getDate()}`;
  document.querySelectorAll('.sv-clock, .mini-sv .clock').forEach(c=>{ c.textContent = `${h12}:${m}`; });
  document.querySelectorAll('.sv-date, .mini-sv .date').forEach(d=>{ d.textContent = dateStr; });
}
updateClock();
setInterval(updateClock, 30000);

/* Big chapter numbers */
document.querySelectorAll('.chapter').forEach((ch, i)=>{
  if(ch.querySelector('.chapter-num')) return;
  const n = document.createElement('span');
  n.className = 'chapter-num';
  n.textContent = String(i+1).padStart(2,'0');
  ch.appendChild(n);
  io.observe(ch);
});

/* Hero canvas particle field */
(function(){
  if(calmMotion || prefersReduced) return;
  const wall = document.querySelector('.wall');
  if(!wall) return;
  const canvas = document.createElement('canvas');
  canvas.className = 'particle-canvas';
  canvas.setAttribute('aria-hidden','true');
  wall.prepend(canvas);
  const ctx = canvas.getContext('2d');
  let w=0, h=0;
  const particles = [];
  const COUNT = 32;
  function resize(){
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    const r = wall.getBoundingClientRect();
    w = r.width; h = r.height;
    canvas.width  = w * dpr;
    canvas.height = h * dpr;
    canvas.style.width  = w+'px';
    canvas.style.height = h+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
  }
  resize();
  window.addEventListener('resize', resize);
  for(let i=0; i<COUNT; i++){
    particles.push({
      x: Math.random()*w,
      y: Math.random()*h,
      r: Math.random()*1.6 + 0.5,
      vx: (Math.random()-.5)*0.14,
      vy: (Math.random()-.5)*0.12 - 0.04,
      a: Math.random()*0.55 + 0.2,
      hue: Math.random() > .5 ? '201,154,75' : '255,252,247'
    });
  }
  let mouseX = -9999, mouseY = -9999;
  wall.addEventListener('mousemove', (e)=>{
    const r = wall.getBoundingClientRect();
    mouseX = e.clientX - r.left;
    mouseY = e.clientY - r.top;
  });
  wall.addEventListener('mouseleave', ()=>{ mouseX = -9999; mouseY = -9999; });
  function render(){
    ctx.clearRect(0,0,w,h);
    particles.forEach(p=>{
      const dx = mouseX - p.x, dy = mouseY - p.y;
      const d2 = dx*dx + dy*dy;
      if(d2 < 18000 && d2 > 1){
        const f = (18000 - d2)/18000 * 0.05;
        const d = Math.sqrt(d2);
        p.vx += (dx/d) * f;
        p.vy += (dy/d) * f;
      }
      p.x += p.vx; p.y += p.vy;
      p.vx *= 0.985; p.vy *= 0.985;
      if(p.x < -4) p.x = w+4;
      else if(p.x > w+4) p.x = -4;
      if(p.y < -4) p.y = h+4;
      else if(p.y > h+4) p.y = -4;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI*2);
      ctx.fillStyle = `rgba(${p.hue},${p.a})`;
      ctx.fill();
    });
    requestAnimationFrame(render);
  }
  render();
})();

/* Scroll-driven page color morph */
(function(){
  if(prefersReduced) return;
  const tints = [
    {match: el => el.classList.contains('ch-day')    || el.classList.contains('views') || el.classList.contains('pricing') || el.classList.contains('capture') || el.id === 'tags', color: '#F3DCB6'},
    {match: el => el.classList.contains('ch-object') || el.classList.contains('privacy') || el.classList.contains('compare'), color: '#1F2A44'},
    {match: el => true, color: '#FFFCF7'} // default
  ];
  const targets = [...document.querySelectorAll('section, .chapter, .hero')];
  const secIO = new IntersectionObserver((entries)=>{
    // find the entry that's most in view
    let best = null, bestRatio = 0;
    entries.forEach(e=>{
      if(e.intersectionRatio > bestRatio){ best = e.target; bestRatio = e.intersectionRatio; }
    });
    if(best){
      const tint = tints.find(t => t.match(best));
      if(tint) document.documentElement.style.background = tint.color;
    }
  }, {threshold:[0.3, 0.6]});
  targets.forEach(t => secIO.observe(t));
})();

/* ------- Nav scroll (compat) ------- */

/* ------- FAQ ------- */
const FAQS = [
  ['Is there a camera or microphone?', "No. Mantle's hardware has neither. It's built for shared visibility, not surveillance."],
  ['Whose calendars does it support?', 'Mantle syncs the calendar apps you already use at home. Everyone keeps their own accounts — nothing is migrated.'],
  ['Does everyone in the house need the app?', 'Each adult and older kid signs in on their phone so locations and handoffs work. Younger kids don’t need one.'],
  ['Will my teenager hate this?', 'The product is designed on the assumption that they won’t accept surveillance. Kids choose their status visibility. Location sharing is consent-based.'],
  ['Do I need Wi-Fi?', 'Yes. Mantle is Wi-Fi only and built as a dedicated kitchen display, not a general-purpose tablet.'],
  ['How does the invite work?', 'Request an invite with the four-question application. Accepted households receive a private link to place a refundable $50 hold that locks the $489 Founding Family price.'],
  ['What is included in the Founding Family run?', 'The first 200 Mantles are numbered and plaqued. The first 50 Architects help co-design the details before the first unit ships.'],
  ['When does it ship?', 'The Founding Family run is planned to ship in Fall 2026, with holiday delivery as the target. We will update accepted households plainly if the schedule changes.'],
  ['What happens after the first 200?', 'The invite list becomes the waitlist for the next production run at the standard $599 launch price. The $489 early-bird price is for accepted Founding Families only.'],
  ['What if my household runs on two homes?', 'Mantle is designed for households with handoffs, co-parents, grandparents, and multiple calendars. The wall should live where the daily plan gets read.'],
  ['Warranty and returns?', 'Put Mantle on your wall for 30 days. If your house does not run quieter, send it back and we pay shipping both ways.'],
  ['How much space does it take on the wall?', 'The display is 11.6-inch matte E Ink, set in an oak or walnut frame. Think small painting, not mounted tablet.'],
];

const list = document.getElementById('faqList');
FAQS.forEach(([q,a], i)=>{
  const el = document.createElement('div');
  el.className = 'faq-item' + (i===0?' open':'');
  el.innerHTML = `
    <div class="faq-q">${q}<span class="faq-toggle"></span></div>
    <div class="faq-a">${a}</div>
  `;
  el.addEventListener('click', ()=> el.classList.toggle('open'));
  list.appendChild(el);
});

/* ------- Hero device showreel — 4-scene sequencer ------- */
(function(){
  const device = document.getElementById('heroDevice');
  if(!device) return;
  const scenes = [...device.querySelectorAll('.scene')];
  const dots   = [...document.querySelectorAll('#heroDots .hero-dot')];
  if(scenes.length < 2) return;
  if(prefersReduced){
    // Pin to scene 1, don't animate, don't cycle
    scenes.forEach((s,i)=> s.classList.toggle('is-active', i===0));
    return;
  }

  let idx = 0;
  let timer = null;
  let paused = false;

  function dwell(i){
    const v = parseInt(scenes[i].dataset.dwell, 10);
    return Number.isFinite(v) ? v : 5000;
  }
  function show(i){
    scenes.forEach((s,k)=> s.classList.toggle('is-active', k===i));
    dots.forEach((d,k)=> d.classList.toggle('is-active', k===i));
    idx = i;
  }
  function schedule(nextIn){
    clearTimeout(timer);
    timer = setTimeout(tick, nextIn);
  }
  function tick(){
    if(paused){ schedule(800); return; }
    const next = (idx + 1) % scenes.length;
    show(next);
    schedule(dwell(next));
  }

  // Pause on hover / touch of the device
  device.addEventListener('mouseenter', ()=> paused = true);
  device.addEventListener('mouseleave', ()=> paused = false);
  device.addEventListener('touchstart', ()=>{ paused = true; }, {passive:true});
  device.addEventListener('touchend',   ()=>{ setTimeout(()=> paused = false, 1500); }, {passive:true});

  // Pause while tab is hidden (battery-friendly)
  document.addEventListener('visibilitychange', ()=>{ paused = document.hidden; });

  // Dot clicks jump to scene + reset timer
  dots.forEach((d,k)=>{
    d.addEventListener('click', ()=>{
      show(k);
      schedule(dwell(k));
    });
  });

  // Kickoff
  schedule(dwell(0));
})();

/* ============================================================
   Compare A/B — assign variant, cookie-stick 30 days, GA4 event
   ============================================================ */
(function(){
  const root = document.documentElement;
  const params = new URLSearchParams(location.search);
  const forced = params.get('compare');
  const themeDefault = root.getAttribute('data-compare-default');
  let variant = null;

  // QA override via URL param
  if (forced === 'wellness' || forced === 'apparent') {
    variant = forced;
  } else if (themeDefault === 'wellness' || themeDefault === 'apparent') {
    // A locked theme setting should beat old visitor cookies so preview/live match.
    variant = themeDefault;
  } else {
    // Cookie-sticky assignment
    const m = document.cookie.match(/(?:^|;\s*)mantle_compare=(wellness|apparent)/);
    if (m) variant = m[1];
  }

  // Theme-setting default override (read from <html data-compare-default>)
  if (!variant) {
    // Random 50/50
    variant = Math.random() < 0.5 ? 'wellness' : 'apparent';
  }
  // Store for 30 days. This also replaces stale cookies when the theme is locked.
  document.cookie = 'mantle_compare=' + variant + '; path=/; max-age=2592000; SameSite=Lax';

  root.setAttribute('data-compare-variant', variant);

  mantleTrack('compare_variant_shown', {
    event_category: 'ab_test',
    event_label: variant,
    variant: variant
  });
})();

/* ============================================================
   Lightweight bot guards for Shopify-managed forms
   ============================================================ */
(function(){
  document.querySelectorAll('form[data-bot-protected]').forEach((form) => {
    if (form.id === 'inviteForm') return;

    const startedAt = Date.now();
    const minSubmitMs = Number(form.dataset.minSubmitMs || 1500);
    const challenge = `${startedAt}:${Math.random().toString(36).slice(2)}`;
    const startedField = form.querySelector('[data-form-started-at]');
    const challengeField = form.querySelector('[data-js-challenge]');

    if (startedField) startedField.value = String(startedAt);
    if (challengeField) challengeField.value = challenge;

    form.addEventListener('submit', (e) => {
      const traps = ['website', 'company', 'url'];
      const trapFilled = traps.some((name) => {
        const input = form.querySelector(`[name="${name}"]`);
        return input && input.value.trim();
      });
      const tooFast = Date.now() - startedAt < minSubmitMs;
      const missingJs = !challengeField || challengeField.value !== challenge;

      if (trapFilled || tooFast || missingJs) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
  });
})();

/* ============================================================
   Invite application — POSTs JSON to n8n webhook, shows states
   ============================================================ */
(function(){
  const form = document.getElementById('inviteForm');
  if (!form) return;

  const btn = form.querySelector('button[type="submit"]');
  const successEl = form.querySelector('.form-success');
  const errorEl = form.querySelector('.form-error');
  const collapseOnSuccess = form.querySelectorAll('.form-field, .form-submit, .form-row');
  const startedAt = Date.now();
  const minSubmitMs = Number(form.dataset.minSubmitMs || 4000);
  const challenge = `${startedAt}:${Math.random().toString(36).slice(2)}`;
  const startedField = form.querySelector('[data-form-started-at]');
  const challengeField = form.querySelector('[data-js-challenge]');

  if (startedField) startedField.value = String(startedAt);
  if (challengeField) challengeField.value = challenge;

  const fakeSuccess = () => {
    // Silently fake-succeed so bots don't learn they were caught.
    collapseOnSuccess.forEach(el => el.hidden = true);
    successEl.hidden = false;
  };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errorEl.hidden = true;

    // Bot traps: hidden fields, impossible speed, or missing JS-issued challenge.
    const trapNames = ['website', 'company', 'url'];
    const trapFilled = trapNames.some((name) => {
      const input = form.querySelector(`[name="${name}"]`);
      return input && input.value.trim();
    });
    const elapsedMs = Date.now() - startedAt;
    const tooFast = elapsedMs < minSubmitMs;
    const missingJs = !challengeField || challengeField.value !== challenge;

    if (trapFilled || tooFast || missingJs) {
      fakeSuccess();
      return;
    }

    // Basic client validation
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const data = Object.fromEntries(new FormData(form).entries());

    // Compose multi-select fields into the n8n payload schema (single string per question)
    const householdLabels = {
      two_parents: 'Two parents at home',
      single_parent: 'Single parent',
      co_parents: 'Co-parents (separate homes)',
      grandparents: 'Grandparents in the home',
      kids_under_6: 'Kids under 6',
      kids_6_11: 'Kids 6-11',
      kids_12_17: 'Kids 12-17',
      pets: 'Pets in the rotation'
    };
    const painLabels = {
      forgotten_handoffs: 'Forgotten pickups or handoffs',
      group_text_chaos: 'Group-text chaos',
      ignored_calendar: 'A shared calendar nobody opens',
      one_person_remembers: 'One person remembers everything',
      location_friction: 'Locations are hard to share',
      kids_aging_out: 'Kids age out of family apps',
      weekend_chaos: 'Weekend logistics fall apart',
      invisible_work: 'The work is invisible to everyone else'
    };
    const householdSelected = Array.from(form.querySelectorAll('input[name="household_traits"]:checked')).map(cb => householdLabels[cb.value] || cb.value);
    if (data.household_other) householdSelected.push(data.household_other);
    data.household = householdSelected.join('; ');
    data.household_traits = householdSelected;
    delete data.household_other;

    const painSelected = Array.from(form.querySelectorAll('input[name="pain_points"]:checked')).map(cb => painLabels[cb.value] || cb.value);
    if (data.pain_other) painSelected.push(data.pain_other);
    data.pain = painSelected.join('; ');
    data.pain_points = painSelected;
    delete data.pain_other;

    data.source = 'mantle_invite_form';
    data.compare_variant = document.documentElement.getAttribute('data-compare-variant') || 'unassigned';
    data.overture_variant = document.documentElement.classList.contains('skip-overture')
      ? 'skipped'
      : (document.documentElement.getAttribute('data-overture-variant') || 'unassigned');
    data.variant = data.compare_variant;
    data.submittedAt = new Date().toISOString();
    data.clientElapsedMs = elapsedMs;
    data.userAgent = navigator.userAgent;
    data.event_id = createMantleEventId();
    data.attribution = typeof window.getAttributionContext === 'function'
      ? window.getAttributionContext()
      : null;
    data.referral = data.attribution ? data.attribution.referral : null;
    data.referral_code = data.referral ? data.referral.code : '';
    delete data.website;
    delete data.company;
    delete data.url;
    delete data.form_started_at;
    delete data.js_challenge;

    // Cloudflare Turnstile (invisible) — server-side validated by the Worker proxy.
    // The widget auto-renders from its `cf-turnstile` class on api.js load and writes the
    // token into <input name="cf-turnstile-response">. Worker fail-closes on missing token.
    const turnstileToken = data['cf-turnstile-response'] || '';
    delete data['cf-turnstile-response'];
    if (turnstileToken) {
      data.cf_turnstile_token = turnstileToken;
    } else if (window.turnstile && typeof window.turnstile.execute === 'function') {
      // No token yet — invisible widget didn't auto-execute. Trigger it now and wait briefly.
      data.cf_turnstile_token = await new Promise((resolve) => {
        let settled = false;
        const finish = (val) => { if (!settled) { settled = true; resolve(val || ''); } };
        const timeoutId = setTimeout(() => finish(''), 5000);
        try {
          window.turnstile.execute('#cf-turnstile-invite', {
            callback: (token) => { clearTimeout(timeoutId); finish(token); },
            'error-callback': () => { clearTimeout(timeoutId); finish(''); }
          });
        } catch (_) {
          clearTimeout(timeoutId);
          finish('');
        }
      });
    }

    const webhookUrl = form.dataset.webhook;
    if (!webhookUrl) {
      // No webhook configured — show error pointing to SETUP.md guidance
      console.warn('[invite] No webhook URL configured. Set theme setting "invite_webhook_url".');
      errorEl.hidden = false;
      return;
    }

    btn.disabled = true;
    const originalLabel = btn.textContent;
    btn.textContent = 'Sending…';

    try {
      const res = await fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);

      // Success — hide form, show confirmation
      collapseOnSuccess.forEach(el => el.hidden = true);
      successEl.hidden = false;
      successEl.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'center' });

      mantleTrack('invite_application_submit', {
        event_id: data.event_id,
        event_category: 'conversion',
        event_label: data.compare_variant,
        compare_variant: data.compare_variant,
        overture_variant: data.overture_variant,
        value: 1,
        currency: 'USD'
      });
    } catch (err) {
      console.error('[invite] Submission failed:', err);
      errorEl.hidden = false;
      btn.disabled = false;
      btn.textContent = originalLabel;
    }
  });
})();
